import script from "./ConfigModifiedIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigModifiedIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigModifiedIndicator.vue?vue&type=style&index=0&id=61477d7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61477d7c"]])

export default __exports__